/**
 * Links dropdown menu
 *  - on group pages
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    let $newContent = $(context);
    let $tables = $newContent.find('table.table');

    if ($tables.length > 0) {
      $tables.each(function(index, item){
        let $table = $(item);
        let $dropbuttons = $table.find('.btn-group.dropdown');

        if ($dropbuttons.length > 0) {
          // Calling init function.
          Drupal.behaviors.groupLinkDropdownMenu.dropbuttonInit($table, context);
        };
      });
    };

  },
  /**
   * DropbuttonInit function - set bootstrap attributes for collapse content
   * & call collapse behavior to prevent that multi dropdown is open at the same time.
   * @param $table
   * @param context
   */
  dropbuttonInit: function($table, context) {
    let $dropButtons = $table.find('.btn-group.dropdown', context);

    $dropButtons.each(function (index, item){
      let attrId = 'dropbutton-menu-' + index;
      let $dropButton = $(item);
      let $dropdownToggle = $dropButton.find('button.dropdown-toggle');
      let $dropdownSubmit = $dropButton.find('button.form-submit');
      let $dropdownMenu = $dropButton.find('ul.dropdown-menu');

      // Remove btn-xs class on buttons.
      $dropdownSubmit.removeClass('btn-xs');
      $dropdownToggle.removeClass('btn-xs');

      // Set right attributes.
      $dropdownToggle.attr('data-toggle', 'collapse');
      $dropdownToggle.attr('data-target', '#' + attrId);
      $dropdownMenu.attr('id', attrId)

      // On click toggle button.
      $dropdownToggle.on('click keydown', function(event){
        if (event.type === 'click' || (event.type === 'keydown' && (event.which === 40 || event.which === 38))) {
          setTimeout(function(){
            let collapseActive = $dropdownMenu.hasClass('in') === true ? true : false;

            // Call Drupal behavior.
            Drupal.behaviors.groupLinkDropdownMenu.collapseAllDropdowns($table, '#' + attrId, collapseActive);
          }, 200);
        }
      });
    });
  },
  /**
   * Collapse all other dropdowns
   * @param $table
   * @param activeID
   * @param collapseActive
   */
  collapseAllDropdowns($table, activeID, collapseActive = false) {
    let $dropButtons = $table.find('button.dropdown-toggle[aria-expanded="true"]');
    collapseActive = collapseActive === true ? 'none' : activeID;

    $dropButtons.each(function(index, toggleButton) {
      let $toggleButton = $(toggleButton);
      let toggleId = $toggleButton.attr('data-target');

      // We not collapse active one if collapseActive is defined.
      if (toggleId !== collapseActive) {
        let $dropButton = $toggleButton.parent();
        let $dropdownToggle = $dropButton.find('button.dropdown-toggle');
        let $dropdownMenu = $dropButton.find('ul.dropdown-menu');

        $dropdownToggle.addClass('collapsed');
        $dropdownToggle.attr('aria-expanded', false);

        $dropdownMenu.removeClass('in');
      };
    });
  },
}
